module.exports = __webpack_public_path__ + "static/media/erbapuraxerjoff.0ae61548.png";